import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const trackingConversionEntity: Entity = {
  model: model,
  repository: repository,
}

export default trackingConversionEntity
